import React from "react";
import styled from "styled-components";
import loadable from "@loadable/component";

import { PageSection } from "../../components/layout/layout-styles";
import { ClearPictureContentFallback } from "../../components/layout/section-skeleton";

const ClearPictureCard = loadable(() => import("./clear-picture-card"));

const Section = styled(PageSection)`
  margin: 0 auto;
  width: 94%;
  max-width: 1040px;
`;

const ClearPictureSection = () => {
  return (
    <Section name="clear-picture" as="section">
      <ClearPictureCard fallback={<ClearPictureContentFallback />} />
    </Section>
  );
};

export default ClearPictureSection;
